export default __webpack_public_path__ + "static/media/montebravo.539671b3.svg";